import { MapPin, Phone, Mail } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_fc40a26d-7ee2-4b99-ac23-dd0e9435603a/artifacts/9ey7cuwh_logo.png";

export const Footer = () => {
  return (
    <footer
      className="bg-[var(--yono-soft-black)] text-[var(--yono-off-white)] mt-0"
      data-testid="site-footer"
    >
      <div className="container-yono py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <img
              src={LOGO_URL}
              alt="YONO"
              className="h-8 w-auto mb-6"
              style={{ filter: "invert(1) brightness(2)" }}
            />
            <p className="text-[14px] leading-[1.8] text-white/75 max-w-md">
              YONO conçoit et fabrique en France des logements bois compacts,
              prêts à installer, pour répondre aux besoins d'hébergement
              d'urgence, saisonnier et temporaire.
            </p>
            <div className="mt-8 text-[11px] tracking-[0.18em] uppercase text-[var(--yono-wood)] font-mono">
              Fabrication française · Près de Nantes
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow text-[var(--yono-wood)] mb-5">Navigation</div>
            <ul className="space-y-3 text-[14px] text-white/80">
              <li><a className="hover:text-[var(--yono-wood)]" href="#produit">Le logement</a></li>
              <li><a className="hover:text-[var(--yono-wood)]" href="#usages">Usages</a></li>
              <li><a className="hover:text-[var(--yono-wood)]" href="#avantages">Avantages</a></li>
              <li><a className="hover:text-[var(--yono-wood)]" href="#showroom">Showroom</a></li>
              <li><a className="hover:text-[var(--yono-wood)]" href="#contact">Demander une étude</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="eyebrow text-[var(--yono-wood)] mb-5">Contact</div>
            <ul className="space-y-4 text-[14px] text-white/85">
              <li className="flex items-start gap-3" data-testid="footer-address">
                <MapPin size={16} className="mt-1 text-[var(--yono-wood)]" />
                <span>
                  9 rue Pasteur<br />
                  44310 Saint-Philbert-de-Grand-Lieu
                </span>
              </li>
              <li className="flex items-center gap-3" data-testid="footer-phone">
                <Phone size={16} className="text-[var(--yono-wood)]" />
                <a href="tel:+33683581804" className="hover:text-[var(--yono-wood)]">
                  06 83 58 18 04
                </a>
              </li>
              <li className="flex items-center gap-3" data-testid="footer-email">
                <Mail size={16} className="text-[var(--yono-wood)]" />
                <a href="#contact" className="hover:text-[var(--yono-wood)]">
                  Formulaire de contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-16 pt-6 flex flex-col md:flex-row justify-between gap-3 text-[11px] tracking-[0.14em] uppercase text-white/50 font-mono">
          <span>© {new Date().getFullYear()} YONO — Tous droits réservés</span>
          <span>Site dédié hébergement · YONO TWIN</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
